// extracted by css-extract-rspack-plugin
export default {"cls1":"StatCells-cls1_-G8","cls2":"StatCells-cls2_gKl StatCells-cls1_-G8"};